import { createAction, createAsyncAction } from 'typesafe-actions';

import type { Notification } from '@portal/api-models';

import type { IsomorphicRequestPayload } from '../types';

import { NotificationActionType } from './actionTypes';
import type { NotificationFilter } from './types';

export const setFilter = createAction(
  NotificationActionType.SET_FILTER
)<NotificationFilter>();

export const toggleDrawer = createAction(NotificationActionType.TOGGLE_DRAWER)<{
  filter?: NotificationFilter;
  visible: boolean;
}>();

export const notificationsRequestAction = createAsyncAction(
  NotificationActionType.GET_ALL_REQUEST,
  NotificationActionType.GET_ALL_SUCCESS,
  NotificationActionType.GET_ALL_FAILURE
)<IsomorphicRequestPayload, Notification[], Error>();

export interface UpdateNotificationReadRequestPayload
  extends IsomorphicRequestPayload {
  uuid: string;
}

export const updateNotificationReadAction = createAsyncAction(
  NotificationActionType.UPDATE_READ_REQUEST,
  NotificationActionType.UPDATE_READ_SUCCESS,
  NotificationActionType.UPDATE_READ_FAILURE
)<UpdateNotificationReadRequestPayload, Notification[], Error>();

export const startPollingNofications = createAction(
  NotificationActionType.WATCH_START
)();

export const stopPollingNofications = createAction(
  NotificationActionType.WATCH_STOP
)();
